/** @format */

import React, { useEffect } from 'react'
import { _$ } from '@king-design/react'
import { Space, Button } from 'antd'
import { useDesigner, TextWidget } from '@designable/react'
import { GlobalRegistry } from '@designable/core'
import { observer } from '@formily/react'
import { transformToSchema, transformToTreeNode } from '@designable/formily-transformer'
import _ from 'lodash'

interface ActionsWidgetProps {
  schema?: any
  onCancel: () => void
  onConfirm: (schema: string) => void
}
export const ActionsWidget: React.FC<ActionsWidgetProps> = observer(
  ({ schema, onCancel, onConfirm }) => {
    const designer = useDesigner()
    useEffect(() => {
      try {
        designer.setCurrentTree(transformToTreeNode(JSON.parse(schema)))
      } catch {}
    }, [schema])
    const supportLocales = ['zh-cn', 'en-us', 'ko-kr']
    useEffect(() => {
      if (!supportLocales.includes(GlobalRegistry.getDesignerLanguage())) {
        GlobalRegistry.setDesignerLanguage('zh-cn')
      }
    }, [])
    return (
      <Space style={{ marginRight: 10 }}>
        <Button onClick={() => onCancel()}>{_$('取消')}</Button>
        <Button
          type="primary"
          onClick={() => {
            const schemaJson = transformToSchema(designer.getCurrentTree())
            if (!schemaJson.form.labelCol) {
              schemaJson.form.labelCol = 6
            }
            if (!schemaJson.form.wrapperCol) {
              schemaJson.form.wrapperCol = 12
            }
            let schema = JSON.stringify(schemaJson)
            if (_.isEmpty(JSON.parse(schema)?.schema?.properties)) {
              schema = ''
            }
            onConfirm(schema)
            onCancel()
          }}
        >
          <TextWidget>Save</TextWidget>
        </Button>
      </Space>
    )
  }
)
